<template lang="pug">
  .cost-center-wrapper
    h2 centro de custo

    .add-cost-center(v-if="!showCreateEdit")
      .buttons
        PButton(color="primary" size="md" @click="genReport") gerar relatório
        PButton(color="warning" size="md" @click="addOredit({})") criar novo centro de custo

    .edit-cost-center(v-else)
      Validate(v-model="costCenter.code" :minLength="3")
        PTextField(label="código" v-focus)
      PTextField(v-model="costCenter.description" label="descrição")
      .buttons
        PButton(color="success" size="md" block @click="save" :loading="saving")
          | {{ costCenter.id ? 'salvar' : 'criar' }}
        PButton(color="danger" size="md" block @click="close") cancelar

    SmartTable.table(name="cost-center-list" v-bind="table", v-model="tableData" ref="table")
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")

          template(v-slot:description="{ columnValue }")
            span.no-wrap(:title="columnValue") {{ columnValue }}

      template(v-slot:detailsBox="{item}")
        .flex
          DBLabel(title="código:", :body="item.code")
          DBLabel(title="descrição:", :body="item.description || 'sem descrição'")

          .buttons
            PButton(color="info" size="md" @click="addOredit(item)" title="editar")
              span.icon-ptt-icons-lapis

            PConfirmButton(text="Excluir este centro de custo?" color="danger" size="md" @click="deleteActivityType(item.id)" title="excluir")
              span.icon-ptt-icons-excluir

</template>

<script>
export default {
  name: 'CostCenter',
  created () {
    this.getData()
  },
  data () {
    return {
      showCreateEdit: false,
      saving: false,
      data: [],
      loading: [],
      costCenter: {
        id: null,
        code: '',
        description: ''
      },
      table: {
        headerItems: [
          {column: 'código', field: 'code', width: '1fr'},
          {column: 'descrição', field: 'description', width: '2fr'}
        ],
        config: {
          perPage: 10,
          startFocusedSearch: 'code',
          defaultSortField: 'code',
          defaultColumnSearch: 'code',
          detailsBox: {
            numberColumnsKeep: 1
          }
        }
      }
    }
  },
  computed: {
    tableData: {
      get () {
        return {
          loading: this.loading,
          loaded: this.data
        }
      },
      set () {}
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const result = await this.$API.activityCostCenter.get()
      if (result.status === 200) {
        this.data = result.data.success
      }
      this.loading = false
    },
    addOredit ({id = null, code = '', description = ''}) {
      this.showCreateEdit = true
      this.costCenter.id = id
      this.costCenter.code = code
      this.costCenter.description = description
    },
    async deleteActivityType (id) {
      try {
        await this.$API.activityCostCenter.delete({id})
        this.$modalDeSucesso('Deletado com sucesso!')
        this.getData()
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e?.data?.error ? e.data.error : 'Nâo foi possível deletar esse centro de custo'
        })
      }
      this.close()
    },
    close () {
      this.$refs.table.closeDetailsBox()
      this.showCreateEdit = false
      this.costCenter = {
        id: null,
        name: '',
        description: '',
        duration: {float: 0}
      }
    },
    async save () {
      this.saving = true
      try {
        await this.$API.activityCostCenter.save(
          {id: this.costCenter.id},
          this.costCenter
        )
        this.$modalDeSucesso('Criado com sucesso!')
        this.getData()
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e?.data?.error ? e.data.error : 'Nâo foi possível realizar essa operação'
        })
      }

      this.saving = false
      this.close()
    },
    async genReport () {
      let result
      try {
        result = await this.$API.activityCostCenterReport.get()
        this.$modalDeSucesso(result.data.success)
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível gerar o relatório')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cost-center-wrapper {
  h2 {
    text-align: center;
  }

  .flex {
    height: 100%;
    display: grid;
    grid-template-columns: 0.5fr 0.5fr;
    grid-row-gap: 30px;

    .buttons {
      grid-column: 1/3;
      justify-self: right;
      align-self: end;

      display: grid;
      grid-gap: 2px;
      grid-auto-flow: column;
    }
  }

  .edit-cost-center {
    display: grid;
    grid-template-columns: 1fr 1fr 0.2fr;
    grid-column-gap: 30px;
    align-items: center;

    .buttons {
      display: flex;
      justify-self: end;
    }
  }

  .add-cost-center {
    display: flex;
    justify-content: flex-end;

    .buttons {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 1px;
      justify-self: right;
    }
  }

  .add-cost-center,
  .edit-cost-center {
    margin-bottom: var(--header-margin-bottom);
  }
}
</style>
